// src/pages/CreatorAnalyticsDashboard.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import CreatorNav from '../components/CreatorNav';
import CreatorTopMenuBar from '../components/CreatorTopMenuBar';
import CreatorMobileBottomNav from '../components/CreatorMobileBottomNav';
import UniversalFooter from '../components/UniversalFooter';
import { BarChart3, TrendingUp, Users, BookOpen, Eye, Clock } from 'lucide-react';

const CreatorAnalyticsDashboard = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-slate-950 text-slate-50">
      <CreatorNav />
      <CreatorTopMenuBar />
      
      <div className="pb-20 md:pb-0">
        <div className="container mx-auto px-4 py-8 max-w-7xl">
          {/* Header */}
          <div className="mb-8">
            <h1 className="text-4xl font-bold text-white mb-2">
              Analytics Dashboard
            </h1>
            <p className="text-slate-400">
              Comprehensive analytics and insights across your entire catalog
            </p>
          </div>

          {/* Coming Soon Card */}
          <div className="max-w-4xl mx-auto">
            <div className="bg-gradient-to-br from-blue-900/20 to-purple-900/20 rounded-2xl border border-slate-700 p-12 text-center">
              <div className="flex justify-center mb-6">
                <div className="w-20 h-20 bg-blue-600/20 rounded-full flex items-center justify-center">
                  <BarChart3 className="w-10 h-10 text-blue-400" />
                </div>
              </div>
              
              <h2 className="text-3xl font-bold text-white mb-4">
                Advanced Analytics Coming Soon
              </h2>
              
              <p className="text-lg text-slate-300 mb-8 max-w-2xl mx-auto">
                We're building comprehensive analytics tools to help you understand your readers and optimize your content strategy.
              </p>

              {/* Feature Preview Grid */}
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8">
                <div className="bg-slate-800/50 rounded-lg p-6 text-left">
                  <TrendingUp className="w-8 h-8 text-green-400 mb-3" />
                  <h3 className="font-semibold text-white mb-2">Engagement Trends</h3>
                  <p className="text-sm text-slate-400">
                    Track reader engagement patterns across all your titles
                  </p>
                </div>

                <div className="bg-slate-800/50 rounded-lg p-6 text-left">
                  <Users className="w-8 h-8 text-purple-400 mb-3" />
                  <h3 className="font-semibold text-white mb-2">Audience Insights</h3>
                  <p className="text-sm text-slate-400">
                    Understand who your readers are and what they love
                  </p>
                </div>

                <div className="bg-slate-800/50 rounded-lg p-6 text-left">
                  <Eye className="w-8 h-8 text-blue-400 mb-3" />
                  <h3 className="font-semibold text-white mb-2">Content Performance</h3>
                  <p className="text-sm text-slate-400">
                    See which chapters and segments resonate most
                  </p>
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8">
                <div className="bg-slate-800/50 rounded-lg p-6 text-left">
                  <Clock className="w-8 h-8 text-amber-400 mb-3" />
                  <h3 className="font-semibold text-white mb-2">Listening Patterns</h3>
                  <p className="text-sm text-slate-400">
                    Discover when and how long readers engage with your books
                  </p>
                </div>

                <div className="bg-slate-800/50 rounded-lg p-6 text-left">
                  <BookOpen className="w-8 h-8 text-teal-400 mb-3" />
                  <h3 className="font-semibold text-white mb-2">Catalog Overview</h3>
                  <p className="text-sm text-slate-400">
                    Get a bird's eye view of your entire NFD-SmartBook<sup className="text-[0.6em]">™</sup> library
                  </p>
                </div>

                <div className="bg-slate-800/50 rounded-lg p-6 text-left">
                  <BarChart3 className="w-8 h-8 text-indigo-400 mb-3" />
                  <h3 className="font-semibold text-white mb-2">Custom Reports</h3>
                  <p className="text-sm text-slate-400">
                    Generate detailed reports tailored to your needs
                  </p>
                </div>
              </div>

              {/* Note about per-book analytics */}
              <div className="bg-blue-900/20 border border-blue-700/30 rounded-lg p-4 mb-6">
                <p className="text-sm text-blue-300">
                  <strong>Note:</strong> Per-book analytics are already available! Access detailed analytics for any individual manuscript from the Author Console.
                </p>
              </div>

              <button
                onClick={() => navigate('/author')}
                className="px-6 py-3 bg-blue-600 hover:bg-blue-700 rounded-lg font-medium transition-colors"
              >
                Back to Author Home
              </button>
            </div>
          </div>
        </div>
      </div>

      <CreatorMobileBottomNav />
      <UniversalFooter />
    </div>
  );
};

export default CreatorAnalyticsDashboard;
